import {ExpressionPath, Expressions, Variable} from '@packages/systems/wfdl';
import {getName} from '@packages/systems/wfdl-Qualified';
import {localesListItemVariable} from '@packages/shared/constants/Render';
import {ExpansionProps} from '../types';

const isLocalesListItemVariable = Variable.equals(localesListItemVariable);

const bindExpressionPath: ExpressionPath = [
  {in: 'Record', at: 'link'},
  {in: 'Call', at: 'arg'},
];

export function replaceLocaleLinkProperties<T extends ExpansionProps>(
  props: T
): T {
  if (getName(props.element.type) !== 'Link') {
    return props;
  }

  const locale = props.pluginsContext.get('Localization')?.get('locale');

  if (!locale) {
    return props;
  }

  const bind = Expressions.getIn(
    Expressions.getElementData(props.element),
    bindExpressionPath
  );

  if (!bind) {
    return props;
  }

  const select = Expressions.getSelect(bind);

  if (!select) {
    return props;
  }

  const variable = Expressions.getVariable(select.from);

  if (!variable || !isLocalesListItemVariable(variable)) {
    return props;
  }

  const classes = locale.active
    ? props.classes.push('w--current')
    : props.classes;
  const attributes = props.attributes.set('hreflang', locale.tag);

  return {...props, classes, attributes};
}
